import TabapayFundingScreen from 'features/moveMoney/screens/dcf/tabapay/TabapayFundingScreen';
import React from 'react';

export default function TabapayFundingScreenPage() {
  return <TabapayFundingScreen />;
}
